<script setup lang="ts">
import { faBars } from '@fortawesome/pro-light-svg-icons';
import { inject } from 'vue';
import { useBreakpoints } from '../../utils/breakpoints';
import type { ComputedLayoutSections, LayoutSections } from '../types/layoutOptions';
import { FontAwesomeIcon } from '@teemill/components';

performance.mark('app-header-setup');

const layoutOptions = inject<ComputedLayoutSections<LayoutSections>>('layoutOptions');
const layoutToggleSidebar = inject<() => void>('layoutToggleSidebar') || (() => {});

const breakpoints = useBreakpoints();
const greaterThanLg = breakpoints.greater('lg');
const smallerThanLg = breakpoints.smaller('lg');
</script>

<template>
  <div
    class="shadow-sm backdrop-blur-md text-[--tml-header-text-color] bg-[--tml-header-background-color]"
  >
    <div
      class="grid grid-flow-col auto-rows-fr h-full m-auto transition-all px-0"
      :class="{ container: greaterThanLg }"
      :style="{
        padding: layoutOptions?.content.width !== 'container' ? '0' : undefined,
        height: layoutOptions?.header.height,
        maxWidth: layoutOptions?.header.width,
        gridAutoColumns: `${layoutOptions?.header.centerLogo ? '1fr' : 'auto'} auto 1fr`,
      }"
    >
      <div
        v-if="layoutOptions?.sidebar.show && !layoutOptions?.sidebar.fixed"
        class="col-start-1 flex items-center cursor-pointer -mr-4"
        @click="
          () => {
            layoutToggleSidebar();
          }
        "
      >
        <div
          class="flex justify-center items-center mx-2 w-10 h-10 rounded-full"
          :style="{
            backgroundColor: 'var(--tml-header-background-color)',
          }"
        >
          <FontAwesomeIcon :icon="faBars" class="fa-lg" />
        </div>
      </div>
      <div
        class="flex items-center col-start-2 px-4"
        :style="{
          maxWidth: layoutOptions?.header.logoMaxWidth || '220px',
          minWidth: smallerThanLg ? 'auto' : layoutOptions?.sidebar.width,
        }"
      >
        <slot name="logo" />
      </div>
      <div class="col-start-3 flex items-center pr-4">
        <slot v-if="layoutOptions?.header.content" name="content" />
      </div>
    </div>
  </div>
</template>
